import { createGlobalStyle } from 'styled-components';
import { colors, newColors } from './themes/variables';
import '@fontsource-variable/inter';
import '@fontsource/inria-serif/300.css';
import '@fontsource/inria-serif/400.css';
import '@fontsource/inria-serif/700.css';
import { mediaq } from '~/themes/style-utils';
export default createGlobalStyle `
  *{
    box-sizing: border-box;
  }

  html,
  body{
    font-family: 'Inter Variable', sans-serif;
    font-weight: 400;
    font-size: 14px;
    padding: 0;
    margin: 0 !important;
    background-color: ${newColors.background};
    ${mediaq.tabsmall `
		font-size: 14px;
		`}
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smooth: never;
  }
  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${colors.inputColour};
    font-size: 14px;
    font-weight: 400;
    opacity: 1; /* Firefox */
    ${mediaq.tabsmall `
		font-size: '14px';
		`}
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${colors.inputColour};
    font-size: 14px;
    font-weight: 400;
    ${mediaq.tabsmall `
		font-size: '14px';
		`}
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    /*color: ${colors.brandMain};*/
    color: ${colors.inputColour};
    font-size: 14px;
    font-weight: 400;
    ${mediaq.tabsmall `
		font-size: '14px';
		`}
  }
  input{
    background-color: transparent;
    color: ${colors.inputColour};
  }
  input:focus,
  button:focus{
    outline: none;
  }
  #root{
    min-height: 100vh;
  }
  .obituary-button {
    display: none;
    ${mediaq.phone `
    display: block;
    width: 100%;
    margin-top: 16px;
    `}
  }
  //global element styling

  h1,
  h2,
  h3,
  h4,
  h5,
  h6{
    font-weight: 500;
  }

  h1{
    font-size:  41px;
  }
  h2{
    font-size:  36px;
  }
  h3{
    font-size:  31px;
  }
  h4 {
    font-size: 16px;
    margin: 0 0 16px 0;
    ${mediaq.tabsmall `
		font-size: 14px;
		`}
  }
  h5{
    font-size:  21px;
  }
  h6{
    font-size:  18px;
  }
  p{
    margin-bottom: 16px;
    line-height: 22px;
    ${mediaq.tabsmall `
    line-height: 20px;
		`}
  }
  strong,b{
    font-weight: 600;
  }
  small{
    font-size: 14px;
  }
  ul, ol{
    li{
      font-weight: 400;
    }
  }
  #mmd_widget_iframe_div {
    padding: 16px;
    width: 100%;
    height: fit-content;
  }
`;
